import React from 'react';
import { FormattedMessage } from 'react-intl';
import { Paper } from '@mui/material';
import { SwitchBox } from '../../molecules/switch-box';
import { FlexibilityTest } from '../../organisms/flexibility/flexibility-command-test';

import { Group } from '../../organisms/group';
import { ServiceAccessInput } from '../../organisms/settings/service-access-input';
import { useSelector } from '../../store/utils';
import { FlexibilityCommandType } from '../../shared';

const DevPreFlexibility = () => {
  const [serviceActive, activeCommand] = useSelector(
    ({ variables }) =>
      [variables.SERVICE_ACTIVE, variables.FLEXIBILITY_ACTIVE_COMMAND] as const
  );

  if (!serviceActive) {
    return (
      <Group
        layout="list"
        title={
          <FormattedMessage
            id="dev_homepage.title"
            defaultMessage="Vývojové menu"
          />
        }
      >
        <ServiceAccessInput />
      </Group>
    );
  }

  return (
    <>
      <Group
        layout="list"
        title={
          <FormattedMessage
            id="pre_flexibility.title"
            defaultMessage="PRE Flexibilita"
          />
        }
      >
        <SwitchBox
          switchVariableId="PRE_FLEXIBILITY_API_ENABLED"
          title={
            <FormattedMessage
              id="pre_flexibility.enabled"
              defaultMessage="Integrace zapnuta"
            />
          }
          fullWidth
        />
      </Group>

      <Group
        layout="list"
        title={
          <FormattedMessage
            id="pre_flexibility.business_flexibility.title"
            defaultMessage="Obchodní flexibilita"
          />
        }
      >
        <FlexibilityTest type={FlexibilityCommandType.PreFlexibility} />

        <Paper>{JSON.stringify(activeCommand)}</Paper>
      </Group>
    </>
  );
};

export default DevPreFlexibility;
